export function chunkUrl(base, [from, to], laneSet) {
  const [path, query = ""] = base.split("?");
  const params = new URLSearchParams(query);
  params.set("from", from);
  params.set("to", to);
  params.set("lane_set", laneSet);
  return `${path}?${params.toString()}`;
}

function skeletons(node, [from, to]) {
  return Array.from(node.querySelectorAll(".tg-cell-skeleton")).filter((cell) => cell.dataset.date >= from && cell.dataset.date <= to);
}

export function swapRange(root, { from, to, rows }) {
  let swapped = 0;
  Object.entries(rows || {}).forEach(([key, html]) => {
    const row = root.querySelector(`.tg-week-row[data-lane-key="${key}"]`);
    if (!row) return;
    const cells = skeletons(row, [from, to]);
    if (cells.length === 0) return;
    cells[0].insertAdjacentHTML("beforebegin", html);
    cells.forEach((cell) => cell.remove());
    swapped += 1;
  });
  return swapped;
}

export function failRange(root, range) {
  skeletons(root, range).forEach((cell) => cell.classList.add("tg-cell-failed"));
}

export function claimRetry(root, key) {
  const retry = root.dataset.tgMonthReload === key;
  delete root.dataset.tgMonthReload;
  return retry;
}

export function onConflict({ retry, root, key, reload, fail, left }) {
  if (retry) {
    left.forEach(fail);
    return false;
  }
  root.dataset.tgMonthReload = key;
  reload();
  return true;
}

export async function loadChunks({ ranges, fetchRange, apply, fail, stale, current }) {
  for (const [index, range] of ranges.entries()) {
    if (!current()) return;
    let result;
    try {
      result = await fetchRange(range);
    } catch (_error) {
      if (current()) fail(range);
      continue;
    }
    if (!current()) return;
    if (result.stale) {
      stale(ranges.slice(index));
      return;
    }
    apply(result.payload);
  }
}
